module.exports = __webpack_public_path__ + "static/img/logo_icon@2x.12c149f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login/logo_icon@2x.png
// module id = GoRI
// module chunks = 1